<!--  -->
<template>
  <div class="add_box">
    <div class="search_box">
      <!-- <div>
        <el-input
          v-model="objr.name"
          style="width:200px;margin-right:10px"
          placeholder="请输入名称"
        />
        <el-button
          type="primary"
          style="margin-left:10px"
          icon="el-icon-search"
          @click="sraw"
        >搜索</el-button>
        <el-button
          type="info"
          icon="el-icon-refresh"
          @click="awered"
        >重置</el-button>
      </div> -->
      <div>
        <!-- <el-button
          type="success"
          icon="el-icon-plus"
          @click="addbit"
        >新增</el-button> -->
        <!-- <el-button
          type="danger"
          icon="el-icon-circle-close"
          @click="gkawer"
          :disabled="selectlist.length == 0"
        >批量关闭</el-button>
        <el-button
          type="danger"
          icon="el-icon-circle-close"
          @click="kawer"
          :disabled="selectlist.length == 0"
        >批量开启</el-button> -->
      </div>
    </div>
    <div class="all_box">
      <div class="left_box">
        <el-table
          ref="singleTable"
          v-loading="loadinginder"
          highlight-current-row
          :data="tableDatacrop"
          max-height="773"
          border
          @row-click="handleCurrentChange"
        >
          <el-table-column
            prop="corp_name"
            label="企业名称"
            align="center"
          />
        </el-table>
      </div>
      <div class="right_box">
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          style="width: 100%;"
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :row-key="rowKey"
        >
          <el-table-column
            type="selection"
            align="center"
            width="55"
            :reserve-selection="true"
          />
          <el-table-column
            prop="corp_id"
            label="企业编号"
            width="350"
            align="center"
          />
          <el-table-column
            prop="user_id"
            label="员工userId"
            width="350"
            align="center"
          />
          <el-table-column
            prop="user_name"
            label="员工姓名"
            width="300"
            align="center"
          />
          <el-table-column
            prop="employee_no"
            label="员工编号"
            align="center"
          />
          <el-table-column
            prop="employee_no"
            label="客服组开关"
            align="center"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.standby_user"
                active-color="#13ce66"
                inactive-color="#ccc"
                :active-value="true"
                :inactive-value="false"
                @change="opdostatuschange(scope.row, $event)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            prop="created_at_text"
            label="创建时间"
            align="center"
            width="180"
          />
          <!-- <el-table-column
            align="center"
            prop="work_status"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button
                type="warning"
                size="mini"
                @click="edit(scope.row)"
              >编辑</el-button>
              <el-button
                type="danger"
                size="mini"
                @click="deleteItem(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <div
          style="margin-top:10px"
          v-if="corp_id!=''"
        >
          <el-button
            type="danger"
            icon="el-icon-circle-close"
            @click="gkawer"
            :disabled="selectlist.length == 0"
          >批量关闭</el-button>
          <el-button
            type="danger"
            icon="el-icon-circle-close"
            @click="kawer"
            :disabled="selectlist.length == 0"
          >批量开启</el-button>
        </div>

      </div>
    </div>

    <pagination-right
      ref="paginationbox"
      :total="newtotalr"
      :page-sizes="[10]"
      :current-page="objr.page"
      @size-change="fetchPageSizer($event)"
      @current-change="fetchCurrentPager"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getcorpList, getwechatcorpuser, addWechatCorpStandbyUser, removeWechatCorpStandbyUser } from '@/api/workWechat.js'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      dialogVisible: false,
      objr: {
        page: 1,
        pageSize: 10
      },
      adtype: null,
      newtotalr: null,
      tableData: [],
      loading: false,
      loadinginder: false,
      tableDatacrop: [],
      originalString: 'internal/ad/getCorpList',
      originalStringtwo: 'internal/ad/getWechatCorpUser',
      corp_id: '',
      selectlist: [],
      selectlistsend: []
    }
  },
  created() {
    this.croplist()
  },
  mounted() {},
  methods: {
    async menuList() {
      // 获取列表
      this.loading = true
      const data = await getwechatcorpuser({ ...this.objr, corp_id: this.corp_id })
      console.log('data', data)
      this.loading = false
      this.tableData = data.data.list
      this.newtotalr = data.data.total
    },
    croplist() {
      this.loadinginder = true
      getcorpList({
        page: 1,
        pageSize: 200
      }).then(res => {
        console.log('res', res)
        this.tableDatacrop = res.data.list
        this.loadinginder = false
      })
    },
    sraw() {
      this.objr.page = 1
      this.objr.page_size = 10
      this.menuList()
    },
    awered() {
      this.objr.page = 1
      this.objr.name = ''
      this.menuList()
    },
    addbit() {
      this.dialogVisible = true
      this.adtype = 1
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.readingcreateview.send(1)
      }, 100)
    },
    edit(item) {
      this.dialogVisible = true
      this.adtype = 2
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.readingcreateview.send(2, item)
      }, 100)
    },
    // 删除
    // async deleteItem(row) {
    //   this.$confirm('是否确定删除该条信息吗', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     closeOnClickModal: false,
    //     type: 'warning'
    //   }).then(async() => {
    //     await weworkPhoneDelete({ id: row.id })
    //     this.menuList()
    //     this.$message({
    //       message: '删除成功',
    //       type: 'success'
    //     })
    //   })
    // },
    // 分页
    fetchPageSizer(e) {
      this.objr.pageSize = e
      this.menuList()
    },
    fetchCurrentPager(e) {
      this.objr.page = e
      this.menuList()
    },
    updatawe(corp_id) {
      this.dialogVisible = false
      this.objr.page = 1
      this.corp_id = corp_id
      this.croplist()
      this.menuList()
    },
    handleCurrentChange(val) {
      console.log('val', val)
      this.corp_id = val.corp_id
      this.objr.page = 1
      this.selectlist = []
      this.$refs.multipleTable.clearSelection()
      this.menuList()
    },
    rowKey(row) {
      return row.id
    },
    handleSelectionChange(rows) {
      this.selectlist = rows //
    },
    kawer() {
      this.selectlistsend = []
      this.selectlistsend = this.selectlist.map((item, index) => {
        // eslint-disable-next-line eqeqeq
        return item.user_id
      })
      addWechatCorpStandbyUser({
        corp_id: this.corp_id,
        user_ids: this.selectlistsend
      }).then(res => {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.selectlist = []
        this.$refs.multipleTable.clearSelection()
        this.menuList()
      })
    },
    gkawer() {
      this.selectlistsend = []
      this.selectlistsend = this.selectlist.map((item, index) => {
        // eslint-disable-next-line eqeqeq
        return item.user_id
      })
      removeWechatCorpStandbyUser({
        corp_id: this.corp_id,
        user_ids: this.selectlistsend
      }).then(res => {
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.selectlist = []
        this.$refs.multipleTable.clearSelection()
        this.menuList()
      })
    },
    opdostatuschange(item, val) {
      console.log('item', item, val)
      // eslint-disable-next-line eqeqeq
      if (val == true) {
        addWechatCorpStandbyUser({
          corp_id: item.corp_id,
          user_ids: [item.user_id]
        }).then(res => {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.menuList()
        })
      } else {
        removeWechatCorpStandbyUser({
          corp_id: item.corp_id,
          user_ids: [item.user_id]
        }).then(res => {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.menuList()
        })
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box {
  padding: 20px;
}
.search_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.left_box {
  width: 200px;
  margin-right: 40px;
}
.all_box {
  display: flex;
  margin-top: 20px;
}
.right_box {
  /* width: 1400px; */
  width: 85%;
}
</style>
